export default __webpack_public_path__ + "static/media/ncsc.48dee944.png";